export default __webpack_public_path__ + "_/shared_modules/common-images/checkmark-outline-green-8315f9250ad5aa12645ef5b15b35dc10.svg";